import { useCallback, useMemo, useState } from 'react';
import { IDistance, IPropCardInfo } from '../../types';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  Container,
} from './styles';
import { FiFolderPlus, FiMinusCircle, FiPlusCircle } from 'react-icons/fi';
import { useAuth } from '../../context/auth';
import { BsStar, BsStarFill } from 'react-icons/bs';
import { toast } from 'react-toastify';
import ModalAddToFolder from '../ModalAddToFolder';

const PLACEHOLDER_IMG =
  'https://portal-nogueira.s3.us-east-2.amazonaws.com/26848b2b91cbd520d366-placeholder-image-nogueira.png';

const INVALID_IMAGE_URLS = new Set([
  'https://www.nogueiracorretores.com.br/',
  'https://www.nogueiracorretores.com.br',
]);

const isValidImageUrl = (url?: string | null) =>
  Boolean(url && url.trim() && !INVALID_IMAGE_URLS.has(url.trim()));

export function CardInfo({ id,id_display, descricao, latitude, longitude, periodo_aluguel, valor_venda, valor_aluguel, is_venda, is_aluguel, arquivos, lat, long, onClick, idBuilding, is_fixado, is_destaque, is_lancamento, is_condominio, ap_bloco, ap_numero, bairro, cidade, marginRight, marginLeft, onSuccessCarrossel }: IPropCardInfo) {

  const { user, api } = useAuth()

  const [destaque, setDestaque] = useState(false)
  const [viewDestaque, setViewDestaque] = useState(false)
  const [addSuccess, setAddSuccess] = useState(false);

  const [revealButton, setRevealButton] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const validImages = useMemo(
    () => (arquivos || []).filter((file) => isValidImageUrl(file?.url)),
    [arquivos],
  );

  const handleImageError = useCallback(
    (event: React.SyntheticEvent<HTMLImageElement>) => {
      const img = event.currentTarget;
      if (img.dataset.fallback === '1') return;
      img.dataset.fallback = '1';
      img.src = PLACEHOLDER_IMG;
    },
    [],
  );

  const handleCloseModal = () => {
    setOpenModal(false);
  }


  const handleOpenModal = () => {
    setOpenModal(true);
  }


  const distance = ({ lat1, lon1, lat2, lon2 }: IDistance) => {
    const earthRadius = 6371; // raio da Terra em km
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
      + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2))
      * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c; // distância em km
    return distance;
  }

  const toRadians = (degrees: number) => {
    return degrees * Math.PI / 180;
  }

  const getDistance = useMemo(() => {
    if (lat && long && latitude && longitude !== null) {
      return distance({ lat1: lat, lon1: long, lat2: Number(latitude), lon2: Number(longitude) });
    } else {
      return -1
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lat, long, latitude, longitude])

  const handleAddToProfile = useCallback(async (idBuilding: number) => {
    await api.post('/portal/seller/add-to-profile', {
      id_corretor: user.id_corretor,
      id_imovel: idBuilding
    }).then(res => {
      setRevealButton(true)
      setAddSuccess(true)
      setViewDestaque(true)
      return toast.success('Imóvel adicionado com sucesso ao seu perfil', {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored'
      })
    }).catch(e => {
      console.log(e)
      return toast.error('Não foi possível adicionar o imóvel ao seu perfil', {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored'
      })
    })
  }, [user, api])

  const handleRemoveToProfile = useCallback(async (idBuilding: number) => {
    await api.post('/portal/seller/remove-from-profile', {
      id_corretor: user.id_corretor,
      id_imovel: idBuilding
    }).then(res => {
      setAddSuccess(false)
      setViewDestaque(false)
      setRevealButton(false)
      return toast.success('Imóvel retirado com sucesso do seu perfil', {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored'
      })
    }).catch(e => {
      console.log(e)
      return toast.error('Não foi possível retirar o imóvel do seu perfil', {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored'
      })
    })
  }, [user, api])

  const handleAddDestaque = useCallback(async (idBuilding: number) => {
    await api.post('/portal/seller/highlight', {
      id_corretor: user.id_corretor,
      id_imovel: idBuilding
    }).then(res => {
      setDestaque(true)
      return toast.success('Imóvel adicionado com sucesso aos seus destaques', {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored'
      })
    }).catch(e => {
      console.log(e)
      toast.error('Não foi possível adicionar o imóvel aos destaques', {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored'
      })
      toast.error('Adicione o imóvel ao seu perfil primeiro', {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored'
      })
    })
  }, [user, api])

  const handleRemoveDestaque = useCallback(async (idBuilding: number) => {
    await api.post('/portal/seller/remove-highlight', {
      id_corretor: user.id_corretor,
      id_imovel: idBuilding
    }).then(res => {
      setDestaque(false)
      return toast.success('Imóvel retirado com sucesso dos seus destaques', {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored'
      })
    }).catch(e => {
      console.log(e)
      return toast.error('Não foi possível retirar o imóvel dos destaques', {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored'
      })
    })
  }, [user, api])

  return (
    <Container marginRight={marginRight} marginLeft={marginLeft} >
      {
        user &&
        <>
          {
            (is_fixado === 1 || addSuccess) ?
              <FiMinusCircle className='icon-add' onClick={() => handleRemoveToProfile(idBuilding)} title='Retirar do perfil' />
              :
              ((is_fixado === null || !addSuccess) ?
                <FiPlusCircle className={'icon-add'} onClick={() => handleAddToProfile(idBuilding)} title='Adicionar ao perfil' />
                :
                <></>
              )
          }
        </>
      }
      {
        (user && (is_fixado === 1 || viewDestaque)) &&
        <>
          {
            (is_destaque === 1 || destaque) ?
              <BsStarFill className='add-destaque-golden' onClick={() => handleRemoveDestaque(idBuilding)} title='Retirar do destaque' />
              :
              ((is_destaque == null || !destaque) ?
                <BsStar className='add-destaque' onClick={() => handleAddDestaque(idBuilding)} title='Adicionar ao destaque' />
                :
                <></>
              )
          }
        </>
      }
      {
        is_lancamento === 1 ?
        <div className='destaque'>
          LANÇAMENTO
        </div>
        :
        <></>
      }
      <div className="img">
        {validImages.length > 0 ? (
          <Carousel
            autoPlay={true}
            interval={5000}
            showThumbs={false}
            infiniteLoop={validImages.length > 1}
            showIndicators={false}
            showStatus={false}
            onClickItem={onClick}
          >
            {validImages.map((file, index) => (
              <img
                key={`${file.url}-${index}`}
                className="img-build"
                src={file.url}
                alt="Imóvel"
                loading="lazy"
                onError={handleImageError}
              />
            ))}
          </Carousel>
        ) : (
          <img
            className="img-placeholder"
            onClick={onClick}
            src={PLACEHOLDER_IMG}
            alt="placeholder-nogueira"
          />
        )}
      </div>
      <div className="wrapper">
        <div className='address-and-distance'>
          <div className='address'>
            <p className='address-build'>{user && <span style={{ fontSize: '13.5px', fontWeight: 'bold', color: '#0E2244' }} className='fw-bold'>{id_display ? id_display : idBuilding}  - </span>}{`${bairro}, ${cidade}`}</p>
            <span>
              {user && (is_fixado === 1 || revealButton) ? (
                <FiFolderPlus className='icon-folder' onClick={handleOpenModal} title='Adicionar a uma pasta' />
              ) : <></>}
            </span>
          </div>
          <p className="info">
            {(Number(getDistance) && getDistance !== -1)
              ? new Intl.NumberFormat('pt-BR', {
                notation: 'compact',
                style: 'unit',
                unit: 'kilometer',
                unitDisplay: "narrow",
              }).format(getDistance)
              : ''
            }
          </p>
        </div>

        <p className='description'>{descricao}</p>

        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
          {
            is_aluguel === 1 ?
            <div>
              <p className='label-imovel'>A partir de:</p>
              <div>
                <p className="period">
                  {valor_aluguel ? Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  }).format(valor_aluguel) : "0,00"}<span>/{periodo_aluguel === 1 ? 'dia' : (periodo_aluguel === 2 ? 'semana' : (periodo_aluguel === 3 ? 'mês' : 'ano'))}</span>
                  <span className='label-imovel'> *</span>
                </p>
              </div>
            </div>
            :
            <></>
          }
          {
            is_venda === 1 ?
            <div>
              <p className='label-imovel'>A partir de:</p>
              <p className="price">
                {valor_venda ? Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL'
                }).format(valor_venda) : "0,00"}
                <span className='label-imovel'> *</span>
              </p>
            </div>
            :
            <></>
          }

          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.25rem" }}>
            {ap_bloco ? <p className='label-imovel'>Bloco: {ap_bloco}</p> : <></>}
            {ap_numero ? <p className='label-imovel'>Unidade: {ap_numero}</p> : <></>}
          </div>
        </div>

        <p className='label-imovel' style={{ fontSize: "0.6rem", opacity: 0.75 }}>* Sujeito a disponibilidade</p>
        
      </div>
      <ModalAddToFolder handleCloseModal={handleCloseModal} openModal={openModal} idImovel={idBuilding} onSuccess={onSuccessCarrossel} />
    </Container>
  );
}
